import React from 'react';
// @ts-ignore
import HosGauge from './hosGauge';
// @ts-ignore
import styles from './HosGauge.module.scss';

export type HosMs = {
  tub?: string | number;
  dr?: string | number;
  sr?: string | number;
  cr?: string | number;
  ct?: string | number;
};

type MaxConfig = {
  tub: number; // break max
  dr:  number; // drive max
  sr:  number; // shift max
  cr:  number; // cycle max
  ct:  number; // cycle tomorrow max (usually same as cycle max)
};

const DEFAULT_MAX: MaxConfig = {
  tub: 8 * 60 * 60 * 1000,     // 8h
  dr:  11 * 60 * 60 * 1000,    // 11h
  sr:  14 * 60 * 60 * 1000,    // 14h
  cr:  70 * 60 * 60 * 1000,    // 70h (8-day)
  ct:  70 * 60 * 60 * 1000     // choose your policy; same as cycle by default
};

const ORDER: Array<{ key: keyof HosMs; label: string }> = [
  { key: 'tub', label: 'BR' },
  { key: 'dr',  label: 'DR' },
  { key: 'sr',  label: 'SR' },
  { key: 'cr',  label: 'CR' },
  { key: 'ct',  label: 'CT' }
];

function clamp01(n: number) { return Math.max(0, Math.min(1, n)); }

function msToHHMM(msLike?: string | number) {
  const n = Math.max(0, Number(msLike ?? 0));
  const h = Math.floor(n / 3_600_000);
  const m = Math.floor(n / 60_000) % 60;
  return `${String(h).padStart(2,'0')}:${String(m).padStart(2,'0')}`;
}

/** pct 0..1 → rgb(255,15,0) .. rgb(48,192,140) */
// function pctToColor(pct: number) {
//   const p = clamp01(pct);
//   const r0=255, g0=15,  b0=0;
// //   const r1=48,  g1=192, b1=140;
// //   const r = Math.round(r0 + (r1 - r0) * p);
// //   const g = Math.round(g0 + (g1 - g0) * p);
// //   const b = Math.round(b0 + (b1 - b0) * p);
//   return `rgb(48, 192, 140)`;
// }

type Props = {
  data: HosMs;             // raw ms values as strings or numbers
  max?: Partial<MaxConfig>; // override defaults if needed
};

export default function HosGauges({ data, max }: Props) {
  const cfg: MaxConfig = { ...DEFAULT_MAX, ...(max || {}) };

  return (
    <div className={styles.row}>
      {ORDER.map(({ key, label }) => {
        const raw = data[key];
        const remain = Math.max(0, Number(raw ?? 0));
        const maxVal = Math.max(1, cfg[key as keyof MaxConfig]);
        const pct = clamp01(remain / maxVal);
        const color = "var(--main-color)";
        const center = msToHHMM(remain);
        return (
          <HosGauge
            key={label}
            pct={pct}
            color={color}
            label={label}
            center={center}
          />
        );
      })}
    </div>
  );
}
